/**
 * Message a afficher sur l'ecran de connexion **a la prochaine ouverture**.
 *
 * Deux evenements se produisent loin de cet ecran et doivent pourtant s'y lire :
 * la session expiree (decouverte par une requete de donnees, puis redirection
 * par React Admin) et le mot de passe remplace (fin de l'ecran de recuperation).
 * Ni l'un ni l'autre n'a de parametre d'URL ou d'etat de navigation fiable : la
 * redirection de React Admin n'en porte pas, et un parametre d'URL se
 * partagerait par copier-coller.
 *
 * **En memoire, jamais en `sessionStorage`** : « rien ne reste dans le
 * stockage » est la promesse faite a un compte refuse a la connexion, et ce
 * message n'a aucune raison de survivre a un rechargement. Il ne contient
 * aucune donnee de compte.
 */
export type LoginNoticeKind = 'session_expired' | 'password_replaced';

let pending: LoginNoticeKind | null = null;

export const setLoginNotice = (kind: LoginNoticeKind): void => {
  pending = kind;
};

/** Lecture sans consommation : le rendu peut etre rejoue (StrictMode). */
export const peekLoginNotice = (): LoginNoticeKind | null => pending;

export const clearLoginNotice = (): void => {
  pending = null;
};
